export default "__VITE_ASSET__qIgDu5$9__"